var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDonation = function SvgDonation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.599,
    height: 22.04,
    viewBox: "0 0 22.599 22.04",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32212321321",
    "data-name": "Group asdasdas",
    transform: "translate(-114.848 -240.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4318",
    "data-name": "Path 4318",
    d: "M195.3,242.891a4.81,4.81,0,0,1,2.481-1.848,4.653,4.653,0,0,1,4.958,1.317,4.826,4.826,0,0,1,.932,2.548,4.88,4.88,0,0,1-1.812,4.285c-2.026,1.88-4.087,3.721-6.134,5.578a.547.547,0,0,1-.863,0c-2.034-1.847-4.075-3.687-6.1-5.545a5.244,5.244,0,0,1-1.81-3.05,4.908,4.908,0,0,1,.79-3.657,3.972,3.972,0,0,1,2.86-1.646,4.693,4.693,0,0,1,4.614,1.927C195.238,242.821,195.26,242.844,195.3,242.891Z",
    transform: "translate(-67.306)",
    fill: "#b5b5c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4319",
    "data-name": "Path 4319",
    d: "M114.85,445.42q0-1.34,0-2.68c0-.562.149-.713.711-.788q1.61-.216,3.216-.458a2.115,2.115,0,0,0,.485-.169c.491-.206.979-.42,1.47-.627a3.384,3.384,0,0,1,2.86.049c1.188.556,2.373,1.116,3.543,1.707a1.927,1.927,0,0,1,.68.614.982.982,0,0,1-.639,1.494,1.652,1.652,0,0,1-.942-.074q-1.868-.688-3.738-1.371c-.373-.137-.658-.033-.771.279s.045.577.418.709c1.367.483,2.731.977,4.105,1.44a2.449,2.449,0,0,0,2.686-.784.663.663,0,0,1,.286-.208c1.848-.648,3.7-1.285,5.548-1.931a2,2,0,0,1,1.511.041,1.945,1.945,0,0,1,.553,3.214,2.763,2.763,0,0,1-1.088.7q-3.211,1.13-6.422,2.262a10.719,10.719,0,0,1-1.424.444,3.538,3.538,0,0,1-2.246-.353c-1.065-.507-2.134-1.008-3.2-1.52a.922.922,0,0,0-.641-.071q-3.09.716-6.182,1.424c-.513.118-.778-.083-.781-.608C114.845,447.24,114.85,446.33,114.85,445.42Z",
    transform: "translate(0 -186.486)",
    fill: "#e7e7eb",
    opacity: 0.28
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDonation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/donation.8c3749b2.svg";
export { ForwardRef as ReactComponent };